import { render, staticRenderFns } from "./CustomBanner.vue?vue&type=template&id=9f5d1ddc&scoped=true&"
import script from "./CustomBanner.vue?vue&type=script&lang=js&"
export * from "./CustomBanner.vue?vue&type=script&lang=js&"
import style0 from "./CustomBanner.vue?vue&type=style&index=0&id=9f5d1ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d1ddc",
  null
  
)

export default component.exports